import FaqRoutesPath from './FaqRoutesPath'

export default Object.values(FaqRoutesPath)
